import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const CustomPhoneInput = (props) => {
    const phoneInput = useRef();
    const params = new URLSearchParams(window.location.search);

    const mobileNumber = params.get("mobile") || "";
    const country_Code = params.get("country_code") || "";

    const [countryCode, setCountryCode] = useState('in');
    const [value, setValue] = useState(props.value || '');

    // Update value from props
    useEffect(() => {
        setValue(props.value || '');
    }, [props.value]);

    useEffect(() => {
        // Fetch user's country code dynamically
        // fetch('http://ip-api.com/json')
        if (country_Code === "") {
            fetch('https://ipwho.is/')
            .then((response) => response.json())
            .then((data) => {
                if (data && data.country_code) {
                    setCountryCode(data.country_code.toLowerCase() || 'in');
                }
            })
            .catch((error) => console.error('Error fetching user location:', error));
        }
    }, []);

    // Update country code from props
    // useEffect(() => {
    //     setCountryCode(props.countryCode || "91");
    // }, [props.countryCode]);

    // Handle phone number change
    const _handleNumberChange = (phone, data) => {

        setCountryCode(data.dialCode);
        setValue(phone);
        props.handleChange?.(phone, data); // Full phone number with country code
    };

    function _handleKeyPress(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault(); // stop form submit
            e.stopPropagation(); // prevent bubbling to parent handlers

            // Run focus after the DOM updates
            setTimeout(() => {
                phoneInput.current?.focus();
            }, 0);
            props.onSubmit();
        }
    }

    return (
        <div className={`${props.wrapperClass} ` } ref={props.ref}>
            {props.label && (
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-alt-font e-font-weight-400 line-height-20px padding-2px-bottom`}>
                    {props.label}
                    {props.required && <span className='color-carmine-pink'>*</span>}
                </label>
            )}

            <PhoneInput
                country={countryCode}

                enableSearch
                searchPlaceholder="Search country here..."
                searchNotFound="No countries found"
                value={value}
                onChange={_handleNumberChange}
                inputProps={{
                    ref: phoneInput,
                    placeholder: props.placeholder || "Enter phone number",
                    onKeyDown: _handleKeyPress,
                }}
                disableCountryGuess={true}
                countryCodeEditable={false}
                containerClass={`custom-phone-container ${props.error ? "error" : ""}`}
                inputClass="custom-phone-input"
                buttonClass="custom-phone-dropdown"
                // disabled={true}
            />

            {props.error && (
                <p className="e-error-msg position-absolute">
                    {props.error}
                </p>
            )}
        </div>
    );
};

CustomPhoneInput.defaultProps = {
    value: '',
    handleChange: () => { },
    // countryCode: '91',
    label: '',
    required: false,
    disabled: false,
    error: '',
    onSubmit: () => { }
};

export default CustomPhoneInput;